import React from 'react';

import facebookIcon from '../../../../icons/facebook-hangin-sign.svg';
import etsyIcon from '../../../../icons/etsy-colordin.svg';

import SvgIcon from '../../SvgIcon/SvgIcon';
import classes from './TrdFallBack.css';

const trdFallBack = () => {
    

   

    return (
        <div className={classes.TrdFallBack}>
            <h1 className={classes.Title}>Come back soon!</h1>
            <h2 className={classes.UntilThen}>Until Then...</h2>
            <h3 className={classes.CheckOutEtsy}>Check us out on Etsy!</h3>
            <div className={classes.EtsyIcon}>
                <SvgIcon  
                    url={"https://www.etsy.com/shop/codaraho?fbclid=IwAR2dq7Boz_gEMUycEig-WC_8WVsLQ0v3eK0U5a2KBKrO6iXWg4SSWYCKhTE"}
                    icon={etsyIcon}
                />
            </div>
            <h3 className={classes.CheckOutFacebook}>And be sure to follow us on Facebook!</h3>
            <div className={classes.FacebookIcon}>
                <SvgIcon 
                    url={"https://www.facebook.com/groups/DiverseMediumDesigns"}
                    icon={facebookIcon}
                />
            </div>
    
        </div>
    )
}   


export default trdFallBack;


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdFallBack/TrdFallBack.js